import { render, staticRenderFns } from "./StatsBox.vue?vue&type=template&id=9edbb08e&"
import script from "./StatsBox.vue?vue&type=script&lang=js&"
export * from "./StatsBox.vue?vue&type=script&lang=js&"
import style0 from "./StatsBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports